import { STORE_LOADER_VISIBLE_ATTRIBUTE, LOGIN_LOADER_BG_MODE_ATTRIBUTE, STORE_LOADING_COVER_BG_DESKTOP_VAR, STORE_LOADING_COVER_BG_MOBILE_VAR } from './StoreLoadingCover.consts';
import {
    buildLoginLoaderBackgroundHtmlStyle,
    readLatchedLoginLoaderBackground,
} from './loginLoaderBackgroundSession';

export const setStoreLoaderVisible = (isVisible: boolean): void => {
    if (typeof document === 'undefined') {
        return;
    }
    if (isVisible) {
        document.documentElement.setAttribute(STORE_LOADER_VISIBLE_ATTRIBUTE, '1');
        return;
    }
    document.documentElement.removeAttribute(STORE_LOADER_VISIBLE_ATTRIBUTE);
};

export const setLoginLoaderBgMode = (isActive: boolean): void => {
    if (typeof document === 'undefined') {
        return;
    }
    if (isActive) {
        document.documentElement.setAttribute(LOGIN_LOADER_BG_MODE_ATTRIBUTE, '1');
        const latchedStyle = buildLoginLoaderBackgroundHtmlStyle(
            readLatchedLoginLoaderBackground() ?? undefined,
        );
        if (latchedStyle) {
            for (const [property, value] of Object.entries(latchedStyle)) {
                if (value) {
                    document.documentElement.style.setProperty(property, value);
                }
            }
        }
        return;
    }
    document.documentElement.removeAttribute(LOGIN_LOADER_BG_MODE_ATTRIBUTE);
    document.documentElement.style.removeProperty(STORE_LOADING_COVER_BG_MOBILE_VAR);
    document.documentElement.style.removeProperty(STORE_LOADING_COVER_BG_DESKTOP_VAR);
};
